import { formatRange } from "./formatRange";
import { useTimelineContext } from "./TimelineContext";
import type { TimelineTrackItem } from "./TimelineTrackItem";

interface SelectionAnnouncementProps {
  /** The selected item; `null` announces nothing. */
  selectedItem: TimelineTrackItem<unknown> | null;
}

/**
 * A visually hidden status line naming the selected item and its range, so a
 * screen reader hears every selection. Derived from the selection rather than
 * from the gesture that made it, so every way of selecting is announced.
 */
export function SelectionAnnouncement({
  selectedItem,
}: SelectionAnnouncementProps) {
  const { format } = useTimelineContext();
  let announcement = "";
  if (selectedItem !== null) {
    const range = formatRange(selectedItem, format);
    announcement = `Selected: ${selectedItem.label}, ${range.start} to ${range.end}, ${range.duration}`;
  }
  return (
    <div role="status" className="sr-only">
      {announcement}
    </div>
  );
}
